<lm-form-content-form
    [formSpec]="formSpec"
    [formOptions]="formOptions"
    [specFields]="specFields"
    [layout]="layout"
    [model]="model"
    [formState]="formState"
    [placeHolder]="placeHolder"
    [formPersonalization]="formPersonalization"
    (fieldEvent)="onFieldEvent($event)"
></lm-form-content-form>
